import { ChangeDetectionStrategy, Component } from '@angular/core';
import { BoxSettings, ColorSettings, SettingsSetterDirective } from 'src/business/models/general-element-settings';
import { UmbracoGridElement } from 'src/layout/grid/models/umbraco-grid-element.interface';


export enum BlockSliderPagination {
    thumbnails = 'thumbnails',
    none = 'none',
    square = 'square',
    circle = 'circle',
    rectangle = 'rectangle',
}

type BoxNColors = Partial<BoxSettings> & Partial<ColorSettings>;

export interface BlockSliderSettings extends BoxNColors {
    gap: string;
    arrows: boolean;
    scrollbar: boolean;
    scrollHint: boolean;
    scrollStart: number;
    showSize: number;
    oneAtATime: boolean;
    minWidth: string;
}

@Component({
    selector: 'app-block-slider-element',
    templateUrl: './block-slider.component.html',
    styleUrls: ['./block-slider.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class BlockSliderComponent extends SettingsSetterDirective {
    declare settings: BlockSliderSettings;
    layout: UmbracoGridElement[];

}
